// src/components/ScrollToTop.js
import React from 'react';

const ScrollToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="scroll-to-top" onClick={scrollToTop}>
      <div>
        <div className="scroll-top-inner">
          <div className="scroll-bar">
            <div className="bar-inner"></div>
          </div>
          <div className="scroll-bar-text">Go To Top</div>
        </div>
      </div>
    </div>
  );
};

export default ScrollToTop;